import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { JiraLogo } from "@atlaskit/logo";
import { token } from "@atlaskit/tokens";

import {
    JiraOverlayTemplate,
    SignupBackgroundLayout
} from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { experiments, ExperimentView } from "@/utils/experiment";

import { CreateASiteHeading } from "../../../components";

export const LoggedInJiraNewUser = () => (
    <ExperimentView
        experiment={experiments.jfindSignUpFlowOverlay}
        render={(value) =>
            value ? (
                <JiraOverlayTemplate size="sm">
                    <Content />
                </JiraOverlayTemplate>
            ) : (
                <SignupBackgroundLayout
                    ProductLogo={<JiraLogo size="xlarge" appearance="brand" />}
                >
                    <Content />
                </SignupBackgroundLayout>
            )
        }
    />
);

const Content = () => {
    const intl = useIntl();

    const subHeaderText = intl.formatMessage({
        id: "siteActivation.loggedInJira.newUser",
        defaultMessage:
            "Sites are the shared space where people organize teams, work, and projects."
    });

    return (
        <div css={containerCss}>
            <div css={headerGroupCss}>
                <h1 css={headerCss}>
                    <span css={accentImageSpanCss}>
                        <CreateASiteHeading />
                    </span>
                </h1>
                <p css={headerCss}>{subHeaderText}</p>
            </div>
            <SiteActivation />
        </div>
    );
};

const containerCss = css({
    display: "flex",
    flexDirection: "column"
});

const headerGroupCss = css({
    display: "grid",
    gap: token("space.100")
});

const headerCss = css({
    margin: 0,
    textAlign: "center"
});

const accentImageSpanCss = css({
    position: "relative"
});
